import BuilderIOSection from "../../builderio/components/builderIOSection";
import { BuilderIOSections } from "../../models/constants";

const Footer = () => {
  return (
    <BuilderIOSection section={BuilderIOSections.StorefrontFooter} /> 
  );
};

export default Footer;
